/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TpnOverview_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TpnRewardsDashboard_viewer$ref: FragmentReference;
export type TpnRewardsDashboard_viewer = {|
  +$fragmentRefs: TpnOverview_viewer$ref,
  +$refType: TpnRewardsDashboard_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TpnRewardsDashboard_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TpnOverview_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd4134d38eeb5121a08286f9f2eb19362';
module.exports = node;
